// deps
import React, { memo } from "react";

export interface PercentIconProps {
    className?: string;
}

const PercentIcon: React.FC<PercentIconProps> = ({ className = "" }: PercentIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="none" className={className}>
            <path
                stroke="url(#sp)"
                strokeLinejoin="round"
                strokeWidth="1.3"
                d="M8.323 22.623C3.655 21.427 1 17.511 1 13.163c0-4.457 2.797-8.427 7.692-9.498m1.555 12.995c-1.388-.472-2.15-1.821-2.15-3.497 0-1.456.6-2.675 1.703-3.262"
            />
            <path
                stroke="#535665"
                strokeLinejoin="round"
                strokeWidth="1.3"
                d="M8.84 15.617c.558.756 1.417 1.228 2.554 1.228 2.149 0 3.336-1.587 3.336-3.677 0-1.899-1.017-3.4-2.871-3.612-.02-.003-.042-.004-.064-.004-.021 0-.043-.002-.065-.004v2.696L6 7.066 10.863 1l.134 2.39.149-.008a3.93 3.93 0 01.25-.01c6.598 0 10.433 4.568 10.433 9.793 0 5.226-3.835 9.835-10.432 9.835-4.782 0-8.105-2.451-9.562-5.805"
            />
            <defs>
                <linearGradient id="sp" x1="5" x2="4.5" y1="16" y2="7" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#535665" />
                    <stop offset="1" stopColor="#535665" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default memo(PercentIcon);
